import Channel, { ChannelDestination } from 'communication/Channel';
import { StreamError } from 'streamsState/store/streamStatuses/StreamErrorState';

export enum StreamStatus {
    NONE = 'NONE',
    PENDING = 'PENDING',
    STREAMING = 'STREAMING',
    STOPPED = 'STOPPED',
}

export interface StreamStateNone {
    status: StreamStatus.NONE;
}
export interface StreamStatePending {
    status: StreamStatus.PENDING;
}

export interface StreamStateStopped {
    status: StreamStatus.STOPPED;
}

export interface StreamStateStreaming<Data> {
    status: StreamStatus.STREAMING;
    data: Data;
}

export type StreamState<Data> =
    | StreamStateNone
    | StreamStatePending
    | StreamStateStreaming<Data>
    | StreamStateStopped;

export type StreamRequest<RequestPayload, Data> = (
    payload: RequestPayload,
    handler: (data: Data) => void
) => Promise<Channel<RequestPayload, Data>>;

export interface StreamStatusState {
    status: StreamStatus;
    statusTime: number;
    channelId?: number;
    channelDestination?: ChannelDestination;
    errors: StreamError[];
}

export type StreamStatusesByStreamKey = {
    [key: string]: StreamStatusState;
};

export interface StreamStatusesState {
    streams: StreamStatusesByStreamKey;
    errors: StreamError[];
}

export const initialStreamStatusState: StreamStatusState = {
    status: StreamStatus.NONE,
    statusTime: new Date().getTime(),
    errors: [],
};

export const initialStreamStatusesState: StreamStatusesState = {
    streams: {},
    errors: [],
};
